// extracted by mini-css-extract-plugin
module.exports = {"sectionBrand":"Brandanchor_sectionBrand__2KzU5","brand":"Brandanchor_brand__38ZGt","brandPage":"Brandanchor_brandPage__2iWF1","principalBrand":"Brandanchor_principalBrand__33AlH"};